module.exports = __webpack_public_path__ + "static/media/kevin-cantillo.96b75422.jpg";